export default __webpack_public_path__ + "static/media/Profile.e7afd349.svg";